// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer_AJ9HY","content":"Footer_content_tJF3W","name":"Footer_name_YwWKv","links":"Footer_links_HVngH","link":"Footer_link_AfJKe"};